import React from 'react';

/**
 * Quick looping drops under the info card / drip strip (see App.css `.info-wrap .bucket-falling-drops`).
 */
export default function BucketFallingDrops() {
  const base = process.env.PUBLIC_URL || '';
  const src = `${base}/images/icons/paint-drop.svg`;

  /* Long cycle = rare repeats; fall itself is only the first ~8% of each cycle (see App.css keyframes) */
  const drops = [
    { left: '22%', delay: '0s', dur: '9.75s' },
    { left: '50%', delay: '3.5s', dur: '10.25s' },
    { left: '78%', delay: '6.85s', dur: '9.5s' },
  ];

  return (
    <div className="bucket-falling-drops" aria-hidden="true">
      {drops.map(({ left, delay, dur }, i) => (
        <img
          key={i}
          className="bucket-falling-drop"
          src={src}
          alt=""
          width={31}
          height={185}
          decoding="async"
          draggable={false}
          style={{
            '--bf-left': left,
            '--bf-delay': delay,
            '--bf-dur': dur,
          }}
        />
      ))}
    </div>
  );
}
